/**
 * Date helpers for the lifecycle dashboard.
 *
 * All of these work on the `YYYY-MM-DD` strings the change/diff API returns, and
 * deliberately go through `Date.UTC` rather than the local-time `Date` parser:
 * `new Date('2026-07-12')` is parsed as UTC midnight and then *rendered* in local
 * time, so anywhere west of Greenwich it reads back as the 11th. Diff days are
 * UTC days, so we keep the whole calculation in UTC.
 */

/** Saturday or Sunday? Drives weekend shading on the chart and the weekend-change warning. */
export function isWeekend(isoDate: string): boolean {
  const [y, m, d] = isoDate.split('-').map(Number)
  if (!y || !m || !d) return false
  const day = new Date(Date.UTC(y, m - 1, d)).getUTCDay()
  return day === 0 || day === 6
}

/** `isoDate` ± n days, still as YYYY-MM-DD. */
export function shiftDate(isoDate: string, days: number): string {
  const [y, m, d] = isoDate.split('-').map(Number)
  const dt = new Date(Date.UTC(y, m - 1, d))
  dt.setUTCDate(dt.getUTCDate() + days)
  return dt.toISOString().slice(0, 10)
}

/** Today, as YYYY-MM-DD. The diff pipeline can't produce a day beyond this. */
export function todayIso(): string {
  return new Date().toISOString().slice(0, 10)
}
